module.exports = __webpack_public_path__ + "static/media/mt1.4e11e939.jpg";